// removed by extract-text-webpack-plugin
module.exports = {"marginTop":"styles__marginTop___3KL8A","tabbedNavRow":"styles__tabbedNavRow___d2eJD"};


//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/components/tabbedCategories/styles.css
// module id = YxN4
// module chunks = 3